import React, { useEffect, useMemo, useState } from "react";
import { History, LocationState } from "history";
import { getOnboardingResult } from '../../../repo/onboarding'
import PageLayout from "../../PageLayout";
import TableActions from "../../../common/table/TableActions";
import {MaterialReactTable, MRT_ColumnDef} from "material-react-table";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ResultPage from "../steps/Result";

export default function Card() {
  const [isLoading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true)
    getOnboardingResult().then(response => {
      setData(response.data || []);
      setLoading(false);
    })
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "OnboardingID",
        accessorKey: "attributes.OnboardingID",
      },
      {
        header: "File",
        accessorKey: "attributes.File",
      },
      {
        header: "Accepted",
        accessorKey: "attributes.Status.Accepted",
      },
      {
        header: "Rejected",
        accessorKey: "attributes.Status.Rejected",
      },
      {
        header: "Onboarded Date",
        accessorKey: "attributes.OnboardedDate",
      },
    ],
    [],
  );

  const actions = [
    {
      label: "Import onboarding file",
      handler: (history: History<LocationState>) => history.push("/onboarding/import"),
    },
  ];

  const viewAction = (row) => {
    setResult(row);
    setOpenPopup(true);
  }

  const handleClose = () => {
    setOpenPopup(false);
    setResult(null);
  }

  return (
    <PageLayout heading="Onboarding" actions={actions} entity="Onboarding">
      {isLoading ? <ProgressIndicator /> :(
        <MaterialReactTable
          columns={columns}
          data={data}
          initialState={{
            showGlobalFilter: true,
            showColumnFilters: false,
            density: "spacious",
          }}
          enableColumnActions={false}
          enableDensityToggle={false}
          enableFullScreenToggle={false}
          enableColumnFilters={false}
          enableHiding={false}
          enableRowActions
          muiTablePaginationProps={{
            rowsPerPageOptions: [5, 10, 20],
          }}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: "",
              size: 100,
            },
          }}
          positionActionsColumn="last"
          renderRowActions={({ row }) => (
            <TableActions
              section="Onboarding"
              onView={() => viewAction(row.original)}
            />
          )}
        />
      )}
      {result && (
        <Dialog
          // maxWidth="xs"
          fullWidth={true}
          scroll="paper"
          onClose={(event, reason) => {
            handleClose();
          }}
          open={openPopup}
        >
          <DialogTitle>
            Onboarding {result.OnboardingID}
          </DialogTitle>
          <DialogContent dividers={true}>
            <ResultPage data={result} />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </PageLayout>
);
}
